/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cloud_logic_custom": [
        {
            "name": "ModelAPI",
            "endpoint": "https://aj7uf9cx3b.execute-api.ap-southeast-2.amazonaws.com/test",
            "region": "ap-southeast-2"
        }
    ]
};


export default awsmobile;
